<script>
export default {
	data() {
		return {
			isModalOpened: false
		};
	},
	watch: {
		isModalOpened(value) {
			this.toggleKeyboardNavigation(value);
		},
		showCalendarTutorial(value) {
			this.toggleKeyboardNavigation(value);
		},
		showWorldTutorial(value) {
			this.toggleKeyboardNavigation(value);
		}
	},
	mounted() {
		if (
			this.showWorldTutorial ||
			this.showCalendarTutorial ||
			this.showGuidedTour
		) {
			this.toggleKeyboardNavigation(true);
		}
	},
	methods: {
		toggleKeyboardNavigation(toggleOff) {
			setTimeout(() => {
				if (this.$refs.view) {
					const viewElement = this.$refs.view.$el || this.$refs.view;

					if (viewElement && viewElement.querySelectorAll) {
						if (toggleOff) {
							viewElement
								.querySelectorAll(
									'[tabindex]:not(.skip-disable), button:not(.skip-disable), input, a'
								)
								.forEach(elem => {
									elem.setAttribute('tabindex', -1);
								});
						} else {
							const query =
								this.showCalendarTutorial || this.showWorldTutorial
									? '[tabindex]:not([disabled]), button, input, a'
									: '[tabindex], button, input, a';

							viewElement.querySelectorAll(query).forEach(elem => {
								elem.setAttribute('tabindex', 0);
							});
						}
					}
				}
			}, 400);
		},
		onModalChanged(modalInfo) {
			this.isModalOpened = modalInfo.isOpened;
			this.$announcer.polite(
				`${modalInfo.name} ${
					modalInfo.isOpened ? this.$t('opened') : this.$t('closed')
				}`
			);
		}
	}
};
</script>
